import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CallbackComponent } from '@components/callback/callback.component';
import { AuthGuard } from 'src/app/shared/auth/auth.guard';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  { path: 'callback', component: CallbackComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'analysis',
        loadChildren: () =>
          import('./modules/analysis/analysis.module').then(
            (m) => m.AnalysisModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'audit',
        loadChildren: () =>
          import('./modules/audit/audit.module').then((m) => m.AuditModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'search',
        loadChildren: () =>
          import('./modules/search/search.module').then((m) => m.SearchModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'superlist',
        loadChildren: () =>
          import('./modules/superlist/superlist.module').then(
            (m) => m.SuperlistModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'management',
        loadChildren: () =>
          import('./modules/management/management.module').then(
            (m) => m.ManagementModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
